import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { orderApi } from "services/order";

const Attachment = () => {
  const [params] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState("");

  const fetchAttachment = async () => {
    const fileName = params.get("file_name");
    if (!fileName) {
      setErrorMessage("添付ファイルを表示できません。");
      return;
    }

    try {
      const res = await orderApi.getAttachment(fileName);
      if (res?.msg) {
        window.location.replace(res.msg);
        return;
      }
      setErrorMessage("添付ファイルを表示できません。");
    } catch (error) {
      setErrorMessage("添付ファイルを表示できません。");
    }
  };

  useEffect(() => {
    fetchAttachment();
  }, []);

  return <div>{errorMessage}</div>;
};

export default Attachment;
